// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__wmGgp","buttons":"Footer_buttons__1RIDg"};